


export const backendUrl = `http://ebback.consinsta.com`;
export const backendUrlUser = `http://ebback.consinsta.com/user`;
export const backendUrlMaterial = `http://ebback.consinsta.com/material`;
export const backendUrlVendor = `http://ebback.consinsta.com/vendor`;
export const backendUrlAccount = `http://ebback.consinsta.com/account`;
